

































































































































import { Prop, Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { SwSlider } from '../sw-slider';
import {
  NodesConfiguration,
  LinkConfiguration,
  ChartConfiguration,
  PingConfiguration,
  AnimationConfig,
  ZoomOption,
  LayoutOptions,
  } from './types';
import KeyLines from './assets/keylines/js/keylines';
const KEYLINES = require('./assets/keylines/vue/vue-keylines');
@Component({
  components: {
    SwIcon,
    SwSlider,
  },
})
export default class SwGraphs extends SwExtendedVue {
  public chart = KEYLINES.Chart;
  public chartOptions: any;
  @Prop() graphId: string;
  @Prop({ default: [] })
  nodeConfig: NodesConfiguration[];
  @Prop({ default: [] })
  linkConfig: LinkConfiguration[];
  @Prop({ default: null })
  chartConfig: ChartConfiguration;
  pingNodes: string[];
  pingConfig: PingConfiguration;
  @Prop({ default: {} })
  animationConfig: AnimationConfig;
  @Prop({ default: 'static/keylines' })
  keylinesPath: string;
  @Prop({ default: 0 })
  minSliderZoom: number;
  @Prop({ default: 5 })
  maxSliderZoom: number;
  @Prop({ default: 1 })
  initSliderZoom: number;
  @Prop({ default: false })
  enableFilter: boolean;
  @Prop({ default: false })
  enableLayoutOptions: boolean;
  @Prop({ default: { animate: true } })
  @Prop({ default: 3 })
  tightValue: number;
  @Prop() zoomOptions: ZoomOption;
  selectedItems: any = [];
  @Prop({ default: 'any' }) nodeDirection: string;
  chartLayoutPromiseObj: any = [];
  // zoomOptions: ZoomOption;
  dataLoaded: boolean = false;
  toggleSelectMode: boolean = false;
  toggleLayouts: boolean = false;
  selectMode: string;
  selectModeIcon: string;
  layoutMode: string;
  layoutModeIcon: string;
  currentZoomVal: number = 0;
  lastZoomVal: number = 0;
  mouseWheelCounter: number = 0;
  maxFreeZoomVal: number = 13;
  min: number = 0;
  max: number = 5;
  zoomVal: number = 0;
  mask: any;
  neighbours: any = {};
  modeSelection: any = {
    drag: {
      icon: 'topo-compass',
      key: '0',
      title: 'Drag Mode',
    },
    select: {
      icon: 'pencil',
      key: '1',
      title: 'Select Mode',
    },
  };
  layoutOptions: any = {
    lens: {
      icon: 'world-net',
      key: '0',
      title: 'Lens',
    },
    tweak: {
      icon: 'topo',
      key: '1',
      title: 'Tweak',
    },
    structural: {
      icon: 'grid',
      key: '2',
      title: 'Structural',
    },
    standard: {
      icon: 'tree',
      key: '3',
      title: 'Standard',
    },
    hierarchy: {
      icon: 'device-hub',
      key: '4',
      title: 'Hierarchy',
    },
    radial: {
      icon: 'share',
      key: '5',
      title: 'Radial',
    },
  };
  layoutObject: LayoutOptions;
  data: any = {};
  created() {
    this.initLocalVars();
    this.setChartOptions();
    this.data = this.makeData();
    this.dataLoaded = true;
/*     graphEventBus.$on(GRAPH_FILTER_EVENT, (eventParam: FilterEventParams) => {
      this.chart.filter(eventParam.filterFunction, { type: 'node' })
      .then((result: any) => {
        // console.warn(`Filter Result: ${result}`);
        if (eventParam.knowResult) {
          graphEventBus.$emit(FILTER_COMPLETE, result);
        }
      });
    }); */
/*     graphEventBus.$on(GRAPH_PING_EVENT, (eventParam: PingEventParams) => {
      this.pingNodes = eventParam.pingNodes;
      this.pingConfig = eventParam.pingOptions;
      this.chartPing();
    }); */
  }
  initLocalVars() {
    this.selectModeIcon = this.modeSelection['drag']['icon'];
    this.layoutModeIcon = this.layoutOptions['lens']['icon'];
    this.layoutMode = 'lens';
    this.selectMode = 'drag';
    this.min = this.minSliderZoom;
    this.max = this.maxSliderZoom;
    this.zoomVal = this.initSliderZoom;
  }
  klReady(chart: KeyLines.Chart) {
    this.chart = chart;
    this.renderGraph();
    // console.warn('Chart Drawn');
  }
  klAll(event: any) {
    const graphEvent = event[0];
    const itemID = event[1];
    let graphItems = null;
    if (graphEvent === 'click') {
      graphItems = this.chart.getItem(itemID);
      this.$emit('onClicked', { x: event[2], y: event[3], items: graphItems, id: itemID });
    } else if (graphEvent === 'contextmenu') {
      graphItems = this.chart.getItem(itemID);
      this.$emit('onContextMenu', { x: event[2], y: event[3], items: graphItems, id: itemID });
    } else if (graphEvent === 'dblclick') {
      graphItems = this.chart.getItem(itemID);
      this.$emit('onDoubleClick', { x: event[2], y: event[3], items: graphItems, id: itemID });
    } else if (graphEvent === 'hover') {
      this.onFocusOnNode(itemID);
      this.$emit('onHover', { x: event[2], y: event[3], items: graphItems, id: itemID });
    }
  }
  renderGraph() {
    this.pingNodes = [];
    this.updateGraph(this.layoutMode, this.layoutObject);
  }
  onFocusOnNode(id: string) {
    let result = null;
    this.neighbours = {};
    if (id === null) {
      this.chart.foreground(() => { return true; }, { type: 'all' });
    } else {
      const graphItems = this.chart.getItem(id);
      if (graphItems['type'] === 'node') {
        result = this.chart.graph()
        .neighbours(graphItems['id'], { direction: this.nodeDirection });
        for (const item of result['nodes']) {
          this.neighbours[item] = true;
        }
        for (const links of result['links']) {
          this.neighbours[links] = true;
        }
        this.neighbours[graphItems['id']] = true;
      }
      if (graphItems['type'] === 'link') {
        result = this.chart.graph()
        .neighbours(graphItems['id'], { direction: this.nodeDirection });
        result['links'] = [graphItems['id']];
        for (const item of result['nodes']) {
          this.neighbours[item] = true;
        }
        for (const links of result['links']) {
          this.neighbours[links] = true;
        }
      }
      this.chart.foreground(this.getNeighbourNodes, { type: 'all' });
    }
  }
  getNeighbourNodes(item: any) {
    return this.neighbours[item.id];
  }
  updateGraph(layout: string, layoutOptions: any) {
    if (this.chart === undefined) {
      return;
    }
    this.formatData();
    Promise.all(this.chartLayoutPromiseObj)
    .then((value) => {
      if (value.length)  {
        this.doLayout(layout, layoutOptions);
      }
    });
  }
  formatData() {
    this.chartLayoutPromiseObj = [];
    try {
      for (const item of this.nodeConfig) {
        this.chartLayoutPromiseObj.push(this.chart.setItem({
          id: item['id'],
          type: 'node',
          t: item['title'],
          fc: item['titleFontColor'],
          fi: {
            t: item['fontIcon'],
            c: item['iconColor'],
          },
          fs: item['fontSize'],
          ff: item['fontFamily'],
          e: item['enlargementFactor'],
          d: item['data'],
        }));
      }
      for (const link of this.linkConfig) {
        this.chartLayoutPromiseObj.push(this.chart.setItem({
          id: link['id'],
          type: 'link',
          id1: link['to'],
          id2: link['from'],
          c: link['linkColor'],
          w: link['linkWidth'],
          a1: link['arrowheadTo'],
          a2: link['arrowHeadFrom'],
          ls: link['linkStyle'],
          d: link['data'],
        }));
      }
    } catch (exec) {
      // console.warn(exec);
    }
  }
  onSelectionChange() {
    const selectedItems: any = [];
    this.selectedItems = [];
    const items = this.chart.selection();
    for (const item of items) {
      const chartItem = this.chart.getItem(item);
      selectedItems.push(chartItem);
      this.selectedItems.push(chartItem);
    }
    this.$emit('getSelections', selectedItems);
    // console.warn('OnSelection', items);
  }

  backToHome() {
    this.currentZoomVal = 0;
    this.lastZoomVal = this.currentZoomVal;
    this.mouseWheelCounter = 0;
    // this.chart.zoom('fit', { animate: true });
    this.changeLayout(this.layoutMode);
    // console.warn('Chart Home');
  }
  getSelectionColour() {
    let colour: string;
    colour = 'rgb(114, 179, 0)';
    return colour;
  }
  doLayout(layout: string, options: any) {
    this.chart.layout(layout, options);
    // console.warn('Chart Layouting');
  }
  makeData() {
    let nodeItems: any[];
    let linkItems: any[];
    let chartItems: any[];
    nodeItems = [];
    linkItems = [];
    chartItems = [];
    for (const item of this.nodeConfig) {
      nodeItems.push({
        id: item['id'],
        type: 'node',
        t: item['title'],
        fc: item['titleFontColor'],
        fi: {
          t: item['fontIcon'],
          c: item['iconColor'],
        },
        fs: item['fontSize'],
        ff: item['fontFamily'],
        e: item['enlargementFactor'],
        d: item['data'],
      });
    }
    for (const link of this.linkConfig) {
      linkItems.push({
        id: link['id'],
        type: 'link',
        id1: link['to'],
        id2: link['from'],
        c: link['linkColor'],
        w: link['linkWidth'],
        a1: link['arrowheadTo'],
        a2: link['arrowHeadFrom'],
        ls: link['linkStyle'],
        d: link['data'],
      });
    }
    chartItems = nodeItems.concat(linkItems);
    // console.warn('Chart making data');
    return {
      type: 'LinkChart',
      items: chartItems,
    };
  }
  randomInt(begin: number, end: number) {
    return Math.floor(Math.random() * (end - begin)) + begin;
  }
  setChartOptions() {
    this.chartOptions = {
      arrows: this.chartConfig['arrows'],
      selectionColor: this.chartConfig['selectionColor'],
      overview: { icon: false, shown: false },
      handMode: true,
      iconFontFamily: this.chartConfig['iconFontFamily'],
      imageAlignment: {},
      selfLinks: this.chartConfig['selfLinks'],
      hover: 250,
      maxItemZoom: this.chartConfig['maxZoom'],
      minZoom: this.chartConfig['minZoom'],
      navigation: {
        shown: this.chartConfig['navigation'],
      },
    };
    // console.warn('Chart Setting Options');
  }
  public chartPing(pingNodes: string[], pingCongif: PingConfiguration) {
    this.chart.ping(pingNodes, {
      c: pingCongif['pingColor'],
      r: pingCongif['pingRadius'],
      w: pingCongif['pingWidth'],
      time: pingCongif['pingTimes'],
      repeat: pingCongif['pingRepeat'],
      lw: pingCongif['pingLinkAnimEffectWidth'],
    });
    // console.warn('Chart pinging');
  }
  public chartFilter(filterFunction: Function, type: string) {
    this.chart.filter(filterFunction, { type })
    .then((filterResult: any) => {
      return filterResult;
    });
  }
  toggleSelectionMode() {
    this.toggleSelectMode = !this.toggleSelectMode;
    // console.warn(`Chart selection Mode ${this.toggleSelectMode}`);
  }
  toggleLayoutOptions() {
    this.toggleLayouts = !this.toggleLayouts;
    // console.warn(`Chart Toggle Mode ${this.toggleLayouts}`);
  }
  changeSelectionMode(mode: string) {
    let hand = this.chart.options().handMode ? true : false; // be careful with undefined
    hand = !hand;
    this.chart.options({ handMode: hand });
    this.selectMode = mode;
    this.selectModeIcon = this.modeSelection[mode]['icon'];
    // // console.warn('Selection mode:', mode, this.selectMode, this.selectModeIcon);
    this.toggleSelectMode = false;
    // console.warn(`Chart Selection Mode ${this.selectMode}`);
  }
  changeLayout(layout: string) {
    const prevLayout = this.layoutMode;
    this.layoutMode = layout;
    this.layoutModeIcon = this.layoutOptions[layout]['icon'];
    this.toggleLayouts = false;
    const tightValue = this.tightValue;
    switch (layout) {
      case 'lens':
        this.layoutObject = {
          fit: true,
          animate: true,
          tidy: true,
          tightness: tightValue,
        };
        this.doLayout(this.layoutMode, this.layoutObject);
        break;
      case 'tweak':
        this.layoutObject = {
          animate: true,
        };
        this.doLayout(this.layoutMode, this.layoutObject);
        break;
      case 'structural':
        this.layoutObject = {
          fit: true,
          animate: true,
          tidy: true,
          tightness: tightValue,
        };
        this.doLayout(this.layoutMode, this.layoutObject);
        break;
      case 'standard':
        this.layoutObject = {
          fit: true,
          animate: true,
          tidy: true,
          tightness: tightValue,
        };
        this.doLayout(this.layoutMode, this.layoutObject);
        break;
      case 'hierarchy':
        if (this.selectedItems.length) {
          this.layoutObject = { top: this.chart.selection(), fit: true, animate: true, tightness: tightValue };
          this.doLayout(this.layoutMode, this.layoutObject);
        } else {
          this.layoutMode = prevLayout;
          this.layoutModeIcon = this.layoutOptions[this.layoutMode]['icon'];
          alert('Please select a node');
        }
        break;
      case 'radial':
        if (this.selectedItems.length) {
          this.layoutObject = { top: this.chart.selection(), fit: true, animate: true, tidy: true, tightness: tightValue };
          this.doLayout(this.layoutMode, this.layoutObject);
        } else {
          this.layoutMode = prevLayout;
          this.layoutModeIcon = this.layoutOptions[this.layoutMode]['icon'];
          alert('Please select a node');
        }
        break;
      default:
    }
    // console.warn(`Chart Layout Mode ${this.layoutMode}`);
  }
  onSliderValChange(val: number) {
    if (
      this.currentZoomVal < this.lastZoomVal &&
      this.currentZoomVal >= this.min
    ) {
      // const level = Math.abs(this.lastZoomVal - val);
      this.doZoom('out');
    } else if (
      this.currentZoomVal > this.lastZoomVal &&
      this.currentZoomVal <= this.max
    ) {
      // const level = Math.abs(this.lastZoomVal - val);
      this.doZoom('in');
    }
    this.lastZoomVal = this.currentZoomVal;
    this.currentZoomVal = val;
    // // console.warn(val);
  }
  graphZoomIn() {
    if (this.currentZoomVal < this.max) {
      this.doZoom('in');
      this.lastZoomVal = this.currentZoomVal;
      this.currentZoomVal = this.currentZoomVal + 1;
      this.mouseWheelCounter = this.mouseWheelCounter + 1;
    }
    /*  // console.warn(
      `Zoom in: CurrentZoomVal: ${this.currentZoomVal}, lastZoomVal: ${
        this.lastZoomVal
      }, MouseWheelCounter: ${this.mouseWheelCounter}`,
    ); */
    // console.warn('Graph Zoom in');
  }
  graphZoomOut() {
    if (this.currentZoomVal > this.min) {
      this.doZoom('out');
      this.lastZoomVal = this.currentZoomVal;
      this.currentZoomVal = this.currentZoomVal - 1;
      this.mouseWheelCounter = this.mouseWheelCounter - 1;
    }
    // // console.warn(
    //   `Zoom in: CurrentZoomVal: ${this.currentZoomVal}, lastZoomVal: ${
    //     this.lastZoomVal
    //   }, MouseWheelCounter: ${this.mouseWheelCounter}`,
    // );
    // console.warn('Graph Zoom out');
  }
  doZoom(option: string, level: number = -1) {
    if (level !== -1) {
      for (let i = 0; i < level; i += 1) {
        this.chart.zoom(option, this.zoomOptions);
      }
    } else {
      this.chart.zoom(option, this.zoomOptions);
    }
    // console.warn('Zooming');
  }
  @Watch('nodeConfig')
  @Watch('linkCOnfig')
  onNodesChanged() {
    // console.warn('Nodes Changed', this.nodeConfig);
    // console.warn('Nodes Changed', this.linkConfig);
    // this.makeData();
    this.klReady(this.chart);
  }
}
